import React, { useEffect, useState } from "react";
import { Collapse, Button, message, Modal } from "antd";
import moment from "moment";
import Countdown from "react-countdown";
import { FaInbox, FaTrash } from "react-icons/fa";
import "./BlockedInventoryContainer.css";
import { useSelector, useDispatch } from "react-redux";
import { setSideTab } from "../../../toolkit/slices/inventories/inventorySlice";
import accessCheckPromise from "../../../../utils/accessCheck";
import AuthorizationError from "../AuthorizationError";
import { addToCartInBulk } from "../../../toolkit/slices/cart/cartSlice";
import { logoutUser } from "../../../toolkit/slices/users/userSlice";

const { Panel } = Collapse;
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const BlockedIventoryContainer = () => {
  const [blockedInv, setBlockedInfo] = useState(null);
  const eliteUserIds = ["651bd4c8ad7773279c5ae380"];
  const [deleted, setDeleted] = useState(false);
  const userId = useSelector((state) => state.user._id);
  const [access, setAccess] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    async function fetchData() {
      try {
        let info = await fetchBlockedInventories();
        setBlockedInfo(info.data);
      } catch (error) {
        console.error("Error fetching blocked inventories: ", error.message);
      }
    }

    fetchData();
  }, [deleted]);
  useEffect(() => {
    dispatch(setSideTab(window.location.pathname));
    accessCheckPromise()
      .then((res) => setAccess(res))
      .catch((error) => {
        dispatch(logoutUser());
      });
  }, []);

  async function fetchBlockedInventories() {
    try {
      let response = await fetch(
        `${apiBaseUrl}/inventoryManagement/displayBlockedInventories`,
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      let responseJson = await response.json();
      return responseJson;
    } catch (err) {
      console.error("Error: ", err.message);
    }
  }

  const performRemove = async (id) => {
    let requestBody = {
      id,
      deleteAll: false,
    };
    const response = await fetch(
      `${apiBaseUrl}/inventoryManagement/archiveBlockedInventory`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );
    const data = await response.json();

    if (data.success) {
      message.success(data.message); // Log the message if success is true
      setDeleted((prev) => !prev);
    } else {
      message.error(data.message); // Log the error message if success is false
    }
  };

  const handleRemove = (e, id) => {
    e.stopPropagation();
    Modal.confirm({
      title: "Delete blocked inventory",
      content: "Are you sure you want to delete this blocked inventory?",
      okText: "Yes",
      cancelText: "No",
      onOk: () => performRemove(id),
    });
  };

  const performAddToCartAndRemove = async (ele) => {
    // console.log("ele is: ", ele);

    dispatch(addToCartInBulk(ele.inventories));

    let requestBody = {
      id: ele._id,
      deleteAll: false,
    };
    const response = await fetch(
      `${apiBaseUrl}/inventoryManagement/archiveBlockedInventory`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );
    const data = await response.json();

    if (data.success) {
      message.success(data.message);
      setDeleted((prev) => !prev);
    } else {
      message.error(data.message);
    }
  };

  const handleAddToCartAndRemove = (e, ele) => {
    e.stopPropagation();
    Modal.confirm({
      title: "Add to cart and delete",
      content:
        "This will add these inventories to cart and remove the block. Do you want to continue?",
      okText: "Yes",
      cancelText: "No",
      onOk: () => performAddToCartAndRemove(ele),
    });
  };

  const performRemoveAll = async () => {
    let requestBody = {
      id: null,
      deleteAll: true,
    };
    const response = await fetch(
      `${apiBaseUrl}/inventoryManagement/archiveBlockedInventory`,
      {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      }
    );
    const data = await response.json();

    if (data.success) {
      message.success(data.message); // Log the message if success is true
      setDeleted((prev) => !prev);
    } else {
      message.error(data.message); // Log the error message if success is false
    }
  };

  const handleRemoveAll = () => {
    Modal.confirm({
      title: "Remove all blocked inventories",
      content:
        "This will archive all blocked inventories. This action cannot be undone. Are you sure?",
      okText: "Yes, remove all",
      cancelText: "Cancel",
      onOk: () => performRemoveAll(),
    });
  };
  if (access == false) {
    return <AuthorizationError />;
  }

  console.log("blockedInv are: ", blockedInv);

  return (
    <div className="parent-padding-container">
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "2rem",
          }}
        >
          <h4 style={{ fontSize: "20px" }}>Blocked Inventories</h4>
          {blockedInv?.length > 0 && (
            <Button className="remove-all-buttonB" onClick={handleRemoveAll}>
              Remove All
            </Button>
          )}
        </div>
        {blockedInv && (
          <Collapse
            accordion
            defaultActiveKey={blockedInv.map((_, index) => index)}
          >
            {blockedInv.map((ele, index) => (
              <Panel
                header={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      {console.log("this is the block inv", blockedInv)}
                      <span style={{ marginRight: "10px" }}>
                        Client: {ele?.partyName || ele?.blockedFor?.name}
                      </span>
                      {ele?.campaignName && (
                        <span style={{ marginLeft: "5rem" }}>
                          Campaign: {ele.campaignName}
                        </span>
                      )}
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      {ele.blockedBy._id == userId ||
                        eliteUserIds.includes(userId) ? (
                        <>
                          <Button
                            type="primary"
                            onClick={(e) => handleAddToCartAndRemove(e, ele)}
                            style={{ marginRight: "2rem" }}
                          >
                            Add to cart & delete
                          </Button>
                          <FaTrash
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={(e) => handleRemove(e, ele._id)}
                          />
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                }
                key={index}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div>
                    <span style={{ fontWeight: "600" }}>Blocked By:</span>{" "}
                    {ele?.blockedBy?.name}
                  </div>
                  <div>
                    <span style={{ fontWeight: "600" }}>Blocked Till:</span>{" "}
                    {moment(ele?.blockedTill).format("MMMM Do YYYY, h:mm:ss a")}
                  </div>
                  <div>
                    <span style={{ fontWeight: "600" }}>Blocked Type:</span>{" "}
                    {ele?.managementBlock
                      ? "Management Block"
                      : ele?.premiumBlock
                        ? "Premium Block"
                        : "Normal Block"
                    }
                  </div>
                  <div>
                    <span style={{ fontWeight: "600" }}>Confirmed By:</span>{" "}
                    {ele?.confirmedBy}
                  </div>
                </div>
                {!ele?.managementBlock && (
                  <>
                    Time Remaining:{" "}
                    <Countdown
                      date={moment(ele?.blockedTill)}
                      className="countdown"
                    />
                  </>
                )}
                <br />
                <br />
                <div className="blocked-inventory-container">
                  {ele?.inventories.map((elem) => (
                    <div key={elem.location} className="blocked-inventory">
                      {/* Render inventory details */}
                      <p>Location: {elem?.locations?.name}</p>
                      <p>
                        Dimensions: {elem?.width} W X {elem?.height} H
                      </p>
                      {/* Add more details as needed */}
                    </div>
                  ))}
                </div>
              </Panel>
            ))}
          </Collapse>
        )}
        {!blockedInv && (
          <div
            style={{
              display: "grid",
              placeItems: "center",
              height: "100%",
              width: "100%",
              color: "gray",
              fontWeight: "600",
              fontSize: "20px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <FaInbox /> No Blocked Inventories
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlockedIventoryContainer;
